module.exports = __webpack_public_path__ + "static/prolacs-logo-white-93099168973ef21267fa0a9df0843f1a.png";